/**
 * section-header-quiero.js
 * Header Quiero Home
 */

(function () {
  'use strict';

  var MIN_CHARS = parseInt(window.__qhSearchMinChars, 10) || 3;
  var MAX_RESULTS = parseInt(window.__qhSearchMaxResults, 10) || 6;
  var DEBOUNCE_MS = 280;
  var collectionSearchCache = {};

  function debounce(fn, delay) {
    var timer;
    return function () {
      var args = arguments;
      var ctx = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, delay);
    };
  }

  function formatMoney(amount) {
    if (amount === null || amount === undefined || amount === '') return '';
    amount = Number(amount);
    return '$ ' + amount.toLocaleString('es-UY');
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function normalizeText(str) {
    return String(str || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function productMatchesQuery(product, query) {
    var haystack = normalizeText([
      product.title,
      product.handle,
      product.vendor,
      product.product_type
    ].join(' '));

    return normalizeText(query)
      .split(/\s+/)
      .filter(Boolean)
      .every(function (part) {
        return haystack.indexOf(part) !== -1;
      });
  }

  function getProductPrice(product) {
    if (!product || !product.variants || !product.variants.length) return '';
    return product.variants[0].price;
  }

  function getProductImage(product) {
    if (product.image && product.image.src) return product.image.src;
    if (product.images && product.images.length && product.images[0].src) return product.images[0].src;
    return '';
  }

  // Colecciones que componen el universo "Quiero Home" (misma lista que layout/theme.liquid).
  // El buscador mira TODAS, no una sola, porque los productos Home estan repartidos.
  var HOME_COLLECTION_HANDLES = [
    'quiero-home', 'quiero-home2', 'mas-vendidos-quiero-home',
    'accesorios-de-cocina', 'termicos', 'organizacion', 'organizadores',
    'adornos', 'mesa-y-cocina', 'textil', 'cajas-y-canastos'
  ];

  // Trae todos los productos de UNA coleccion, paginando (products.json topea en 250 por pagina).
  function fetchOneCollection(handle, signal) {
    if (!handle) return Promise.resolve([]);

    if (!collectionSearchCache[handle]) {
      var MAX_PAGES = 4; // hasta 1000 productos por coleccion
      var acc = [];
      var loadPage = function (p) {
        return fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=250&page=' + p, {
          credentials: 'same-origin',
          signal: signal
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Collection search unavailable');
            return response.json();
          })
          .then(function (data) {
            var list = (data && Array.isArray(data.products)) ? data.products : [];
            acc = acc.concat(list);
            if (list.length === 250 && p < MAX_PAGES) return loadPage(p + 1);
            return acc;
          });
      };

      collectionSearchCache[handle] = loadPage(1).catch(function (error) {
        delete collectionSearchCache[handle];
        throw error;
      });
    }

    return collectionSearchCache[handle];
  }

  // Junta los productos de varias colecciones Home y los deduplica por id.
  function fetchHomeProducts(handles, signal) {
    var list = (handles || []).filter(Boolean);
    if (!list.length) return Promise.resolve([]);

    return Promise.all(list.map(function (h) {
      return fetchOneCollection(h, signal).catch(function () { return []; });
    })).then(function (lists) {
      var seen = {};
      var merged = [];
      lists.forEach(function (arr) {
        arr.forEach(function (p) {
          if (p && !seen[p.id]) {
            seen[p.id] = 1;
            merged.push(p);
          }
        });
      });
      return merged;
    });
  }

  function initScroll() {
    var header = document.getElementById('header-quiero') || document.getElementById('qh-header');
    if (!header) return;

    function onScroll() {
      if (window.scrollY > 40) header.classList.add('scrolled');
      else header.classList.remove('scrolled');
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initSearch(inputEl, resultsEl) {
    if (!inputEl || !resultsEl) return;

    var currentQuery = '';
    var allMatches = []; // todos los productos Home que matchean (para "ver todos")
    var SHOW_ALL_CAP = 60;

    function showResults() {
      resultsEl.classList.add('is-open');
    }

    function hideResults() {
      resultsEl.classList.remove('is-open');
      resultsEl.innerHTML = '';
    }

    function renderLoading() {
      resultsEl.innerHTML = '<div class="qh-search-loading">Buscando...</div>';
      showResults();
    }

    function renderEmpty(q) {
      resultsEl.innerHTML = '<div class="qh-search-empty">Sin resultados para "<strong>' + escHtml(q) + '</strong>"</div>';
      showResults();
    }

    function renderItems(products, query, showAll) {
      var full = products || [];
      var limit = showAll ? SHOW_ALL_CAP : MAX_RESULTS;
      var list = full.slice(0, limit);

      if (!list.length) {
        renderEmpty(query);
        return;
      }

      var html = '';

      list.forEach(function (p) {
        var imageUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : getProductImage(p);
        var productUrl = p.url || ('/products/' + p.handle);
        var productPrice = p.price_min !== undefined ? p.price_min : getProductPrice(p);

        var imgTag = imageUrl
          ? '<img class="qh-search-item__img" src="' + escHtml(imageUrl) + '" alt="' + escHtml(p.title) + '" loading="lazy">'
          : '<div class="qh-search-item__img-placeholder"></div>';

        var price = productPrice !== ''
          ? '<span class="qh-search-item__price">' + formatMoney(productPrice) + '</span>'
          : '';

        html += ''
          + '<a class="qh-search-item" href="' + escHtml(productUrl) + '">'
          +   imgTag
          +   '<div class="qh-search-item__info">'
          +     '<div class="qh-search-item__title">' + escHtml(p.title) + '</div>'
          +     price
          +   '</div>'
          + '</a>';
      });

      // Botón inferior: lleva a la página de resultados con el filtro aplicado.
      html += '<a class="qh-search-viewall" href="/search?q=' + encodeURIComponent(query) + '&type=product">Ver todos los resultados de "' + escHtml(query) + '"</a>';

      resultsEl.innerHTML = html;
      showResults();
    }

    function runSearch(query) {
      if (!query || query.length < MIN_CHARS) {
        hideResults();
        return;
      }

      currentQuery = query;
      renderLoading();

      var collectionHandle = inputEl.getAttribute('data-qh-search-collection') || '';
      var primaryHandle = collectionHandle || 'quiero-home';

      // Buscar en TODAS las colecciones Home (la configurada + la lista conocida), sin duplicar.
      var handles = [primaryHandle];
      HOME_COLLECTION_HANDLES.forEach(function (h) {
        if (handles.indexOf(h) === -1) handles.push(h);
      });

      // Sin abort: los productos de cada colección se cachean y se reusan entre búsquedas.
      // Para no pintar resultados viejos, comparamos contra currentQuery.
      fetchHomeProducts(handles)
        .then(function (products) {
          if (query !== currentQuery) return;
          allMatches = products.filter(function (product) {
            return productMatchesQuery(product, query);
          });
          renderItems(allMatches, query, false);
        })
        .catch(function () {
          if (query !== currentQuery) return;
          renderEmpty(query);
        });
    }

    var doSearch = debounce(runSearch, DEBOUNCE_MS);

    inputEl.addEventListener('input', function () {
      doSearch(this.value.trim());
    });

    // Botón de la lupa: dispara la búsqueda (muestra el dropdown filtrado).
    var searchWrap = inputEl.closest('.qh-search__wrap');
    var searchBtn = searchWrap ? searchWrap.querySelector('.qh-search__btn') : null;
    if (searchBtn) {
      searchBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var q = inputEl.value.trim();
        if (q.length >= MIN_CHARS) {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        } else {
          inputEl.focus();
        }
      });
    }

    inputEl.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var q = this.value.trim();
        if (q.length >= MIN_CHARS) {
          window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        }
      }

      if (e.key === 'Escape') {
        hideResults();
        this.blur();
      }
    });

    document.addEventListener('click', function (e) {
      if (!inputEl.contains(e.target) && !resultsEl.contains(e.target)) {
        hideResults();
      }
    });
  }

  function applyHeaderCartCount(cart) {
    if (!cart || typeof cart.item_count === 'undefined') return;

    var count = String(cart.item_count);
    var countEls = document.querySelectorAll(
      '[data-header-cart-count], .header-quiero__count, .qh-header__count, [data-cart-count]'
    );

    countEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    });
  }

  function syncHeaderCartCount() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { applyHeaderCartCount(cart); })
      .catch(function () {});
  }

  function openCartDrawer() {
    var qhDrawer = document.querySelector('[data-qh-cart-drawer]');
    if (qhDrawer) {
      document.dispatchEvent(new CustomEvent('qh:cart:open'));
      return true;
    }

    var drawer = document.querySelector('cart-drawer');
    if (drawer) {
      if (typeof drawer.open === 'function') {
        drawer.open(document.querySelector('#qh-cart-icon-bubble, #cart-icon-bubble'));
        return true;
      }

      drawer.classList.add('active');
      drawer.classList.remove('is-empty');
      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
      return true;
    }

    var notification = document.querySelector('cart-notification');
    if (notification && typeof notification.open === 'function') {
      notification.open();
      return true;
    }

    return false;
  }

  function patchFetch() {
    if (window.__qhCartFetchPatched) return;
    window.__qhCartFetchPatched = true;

    var originalFetch = window.fetch;
    if (!originalFetch) return;

    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
      var isCartAdd = url.indexOf('/cart/add') !== -1;

      return originalFetch.apply(this, arguments).then(function (response) {
        if (isCartAdd && response && response.ok) {
          setTimeout(function () {
            syncHeaderCartCount();
            openCartDrawer();
          }, 280);
        }
        return response;
      });
    };
  }

  function openDrawer() {
    var drawer = document.getElementById('quiero-drawer');
    if (!drawer) return false;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('overflow-hidden');
    document.body.classList.add('overflow-hidden');
    return true;
  }

  function closeDrawer() {
    var drawer = document.getElementById('quiero-drawer');
    if (!drawer) return false;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
    return true;
  }

  function bindBurger() {
    var burger =
      document.getElementById('qh-burger') ||
      document.querySelector('.header-quiero__menu') ||
      document.querySelector('.qh-header__burger');

    if (!burger) return;

    burger.addEventListener('click', function (e) {
  e.preventDefault();
  openDrawer();
});
  }

  function bindDrawerClose() {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });

    document.addEventListener('click', function (e) {

      // Cerrar drawer
      if (e.target.closest('[data-drawer-close], .quiero-drawer__overlay, .drawer-header__close')) {
        closeDrawer();
        return;
      }

      // Nivel 2 - PRIMERO para que no lo capture el nivel 1
      var btn2 = e.target.closest('[data-drawer-toggle2]');
      if (btn2) {
        var item2 = btn2.closest('.drawer-subnav__item');
        if (!item2) return;
        var sub2 = item2.querySelector('[data-drawer-subsubnav]');
        if (!sub2) return;
        var expanded2 = btn2.getAttribute('aria-expanded') === 'true';
        btn2.setAttribute('aria-expanded', expanded2 ? 'false' : 'true');
        sub2.hidden = expanded2;
        return;
      }

      // Nivel 1
      var btn = e.target.closest('[data-drawer-toggle]');
      if (!btn) return;
      var item = btn.closest('.drawer-nav__item');
      if (!item) return;
      var sub = item.querySelector('[data-drawer-subnav]');
      if (!sub) return;
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.hidden = expanded;
    });
  }

  function applyLogoWidth() {
    var header = document.getElementById('qh-header') || document.getElementById('header-quiero');
    if (!header) return;

    var w = header.getAttribute('data-logo-w');
    var wm = header.getAttribute('data-logo-w-mobile');

    if (w) document.documentElement.style.setProperty('--logo-w', w + 'px');
    if (wm) document.documentElement.style.setProperty('--logo-w-mobile', wm + 'px');
  }

  function init() {
    initScroll();
    applyLogoWidth();
    patchFetch();
    bindBurger();
    bindDrawerClose();

    initSearch(
      document.getElementById('qh-search-input-desktop'),
      document.getElementById('qh-search-results-desktop')
    );

    initSearch(
      document.getElementById('qh-search-input-mobile'),
      document.getElementById('qh-search-results-mobile')
    );

    var cartIcon =
      document.getElementById('qh-cart-icon-bubble') ||
      document.querySelector('[data-qh-cart-trigger]') ||
      document.getElementById('cart-icon-bubble') ||
      document.querySelector('[data-open-cart-drawer]');

    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var opened = openCartDrawer();
        if (!opened) window.location.href = '/cart';
      });
    }

    syncHeaderCartCount();

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      setTimeout(function () {
        syncHeaderCartCount();
        openCartDrawer();
      }, 700);
    }, true);

    document.addEventListener('cart:updated', function (event) {
      if (event.detail && typeof event.detail.item_count !== 'undefined') {
        applyHeaderCartCount(event.detail);
      } else {
        syncHeaderCartCount();
      }
    });
  }

  window.openDrawer = openDrawer;
  window.closeDrawer = closeDrawer;
  window.openCartDrawer = openCartDrawer;
  window.syncHeaderCartCount = syncHeaderCartCount;
  window.applyHeaderCartCount = applyHeaderCartCount;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
